import { Facebook, Instagram, Linkedin, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_proplandpro/artifacts/lv2qzyun_inmopages-fondooscuro.png" 
                alt="InmoPages" 
                className="h-8"
              />
            </div>
            <p className="text-gray-400 mb-4">
              Plataforma SaaS para crear landing pages profesionales de propiedades inmobiliarias.
            </p>
            <div className="flex space-x-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-gray-800 rounded-lg hover:bg-brand-purple transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-gray-800 rounded-lg hover:bg-brand-pink transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-gray-800 rounded-lg hover:bg-brand-purple transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Navegación</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection("funcionalidades")}
                  className="hover:text-brand-purple transition-colors"
                >
                  Funcionalidades
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("como-funciona")}
                  className="hover:text-brand-purple transition-colors"
                >
                  Cómo Funciona
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("precios")}
                  className="hover:text-brand-purple transition-colors"
                >
                  Precios
                </button>
              </li>
              <li>
                <Link
                  to="/precios"
                  className="hover:text-brand-purple transition-colors"
                >
                  Ver Todos los Planes
                </Link>
              </li>
            </ul>
          </div>

          {/* Cuenta */}
          <div>
            <h3 className="text-white font-bold mb-4">Tu Cuenta</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/login"
                  className="hover:text-brand-purple transition-colors"
                >
                  Iniciar Sesión
                </Link>
              </li>
              <li>
                <Link
                  to="/register"
                  className="hover:text-brand-purple transition-colors"
                >
                  Crear Cuenta
                </Link>
              </li>
              <li>
                <Link
                  to="/admin/dashboard"
                  className="hover:text-brand-purple transition-colors"
                >
                  Panel de Control
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold mb-4">Soporte</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <Mail className="w-5 h-5 text-brand-purple flex-shrink-0" />
                <a
                  href="mailto:soporte@inmopages.app"
                  className="hover:text-brand-purple transition-colors"
                >
                  soporte@inmopages.app
                </a>
              </li>
            </ul>
            <p className="text-gray-500 text-sm mt-4">
              Respuesta en menos de 24 horas hábiles
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} InmoPages. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="hover:text-brand-purple transition-colors">
                Política de Privacidad
              </a>
              <a href="#" className="hover:text-brand-purple transition-colors">
                Términos y Condiciones
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
